"use strict";

class ProgramOverviewCtrl
{
	constructor ($scope, $rootScope, $http, $timeout, $state, Program, $mdDialog, $mdToast, $filter, itemFilters, filterMap, paginationService, $transitions ) {

		// Dependencies
		this.$http = $http;
		this.$timeout = $timeout;
		this.$state = $state;
		this.$mdDialog = $mdDialog;
		this.$mdToast = $mdToast;
		this.paginationService = paginationService;
        this._Program = Program;

		// Controller vars
		this.$filter = $filter;
		this.itemFilters = itemFilters;
		this.filterMap = filterMap.userFilters;
		this.loaded = false;
        this.selectedTab = 0;
        this.inactive = false;
		this.deletedId = false;

		// Paginator
		this.pagination = {
			current: 1
		};

		// Watchers
        $rootScope.checkActive = (program) => {
            return program.id == $state.params.programId;
        };

        $rootScope.isDisabled = (program) => {
            return program.disabled;
        };


        let unregister = $transitions.onSuccess({ }, function(transition) {

            let toState = transition.to();
            if( toState.name === 'program' ) {
                this.fetch();
            }
        });

        $scope.$on('$destroy', () => {
            unregister();
        });

        // Fetch the overview items
        if ($state.params.programId) {
            $http.get('/programs/findpage/'+ $state.params.programId).then((response) => {
                this.fetch(response.data);
                this.pagination.current = response.data;
            });
        } else {
            this.fetch(1);
        }
	}

	fetch(pageNumber) {
        let filters = [];
        this.filterMap.map((filter) => {

            if (filter.enabled) {
                filters.push(filter.id);
            }
        });

		this.$http.get('/programs_overview/?page=' + pageNumber + '&filters=' + filters + "&inactive=" + this.inactive)
			.then((response) => {
				this.programs = response.data.data;
				this.totalResults = response.data.total;
				this.resultPerPage = response.data.per_page;

				if (this.deletedId) {
					for (let key in this.programs) {
						if (this.programs[key].id == this.deletedId) {
							this.programs.splice(key, 1);
							this.totalResults--;
						}
					}
					this.deletedId = false;
				}

				this.$timeout(() => {
					this.loaded = true;
				});
			});

		this.$http.get('/modeltypes_options/program')
			.then((response) => {
				this.program_options = response.data;
			});

		this.pageChanged = function(newPage) {
			getResultsPage(newPage);
		};
	}

	destroy(id, title, ev) {

		ev.stopPropagation();

		this.$http.post('deletewarning', {model : 'program', id : id}).then((response) => {
			this.$mdDialog.show( {

				controller: 'ConfirmManyDialogCtrl',
				templateUrl: "confirmManyDialog.ngTemplate",
				parent: angular.element(document.querySelector('#popupContainer')),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {
					count: response.data,
					option: null
				}
			}).then( () => {

				this.loaded = false;
				this._Program.delete({id: id}, (response) => {

					if (typeof response.error == 'string') {
						this.$mdToast.show({
							templateUrl: '/partial/app.partials.toasts.error_message?object=program&error='+response.error, //@trans('labels.program')
							hideDelay: 3000,
							position: ('top right')
						});
					} else {
						this.$mdToast.show({
							templateUrl: '/partial/app.partials.toasts.queued_delete?object=program&title='+title, //@trans('labels.program')
							hideDelay: 3000,
							position: ('top right')
						});
					}

					this.programs = [];
					this.deletedId = id;
					this.fetch(this.paginationService.getCurrentPage('overview'));
					this.$state.go('programs');
				});

			});
		});

	}

    /**
     * Returns true or false depending on if the item.model_type_id is in the filterArray
     * @param  {object} item
     * @return {boolean}
     */
    updateFilters() {

        let filters = [];
        this.filterMap.map((filter) => {

            if (!filter.enabled) {
                filters.push(filter.id);
            }
        });

        this.$http.post('/userfilters/program', {
            program_filter: filters
        }).then(() => {
            this.fetch(1);
        });
    }
}

ProgramOverviewCtrl.$inject = ['$scope', '$rootScope', '$http', '$timeout', '$state', 'Program', '$mdDialog', '$mdToast', '$filter', 'itemFilters', 'filterMap', 'paginationService', '$transitions'];

module.exports = ProgramOverviewCtrl;
